export const Keyboard = {
  keys: new Set(),
  get space() {
    return Keyboard.keys.has(32);
  },
  get left() {
    return Keyboard.keys.has(37) || Keyboard.keys.has(65);
  },
  get up() {
    return Keyboard.keys.has(38) || Keyboard.keys.has(87);
  },
  get right() {
    return Keyboard.keys.has(39) || Keyboard.keys.has(68);
  },
  get down() {
    return Keyboard.keys.has(40) || Keyboard.keys.has(83);
  },
  get x() {
    return Number(Keyboard.right) - Number(Keyboard.left);
  },
  get y() {
    return Number(Keyboard.up) - Number(Keyboard.down);
  },
};

addEventListener("keydown", ({ keyCode }) => {
  Keyboard.keys.add(keyCode);
});
addEventListener("keyup", ({ keyCode }) => {
  Keyboard.keys.delete(keyCode);
});
